import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import { Communicators } from 'presentation/components/lib/communicators';
import EndMessageContainer from 'presentation/containers/EndMessageContainer';
import Message from 'presentation/components/Message';
import MessageStack from 'presentation/components/MessageStack';
import overrideStyle from 'lib/overrideStyle';
import SelectedAnswerHistoryItemContainer from 'presentation/selfService/SelectedAnswerHistoryItem';
import TypingIndicator from 'presentation/components/TypingIndicator';
import WelcomeMessageContainer from 'presentation/containers/WelcomeMessageContainer';

import styles from 'presentation/components/styles/ChatHistory.css';
let cx = classnames.bind(styles);

class ChatHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldDisplayAutoResponse: this.props.isSelfService && this.props.messageHistory.length > 1,
    };
  }

  componentDidUpdate(prevProps) {
    this.containerElement.scrollTop = this.containerElement.scrollHeight;
    // if the first message has been sent, wait 1 second before displaying the autoresponse
    if (
      this.props.isSelfService &&
      !this.state.shouldDisplayAutoResponse &&
      prevProps.messageHistory.length !== this.props.messageHistory.length &&
      this.props.messageHistory.length === 2
    ) {
      this.timeout = setTimeout(() => {
        this.setState({ shouldDisplayAutoResponse: true });
      }, 1000);
    }
  }

  componentDidMount() {
    this.containerElement.scrollTop = this.containerElement.scrollHeight;
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  renderMessageHistory() {
    let renderedHistory = [];
    let renderedMessages = [];

    this.props.messageHistory.forEach((message, index, messages) => {
      let sender = getSender(message);
      let nextSender = getSender(messages[index + 1]);
      renderedMessages.push(<Message sender={sender} content={message.content.body} key={message.id} />);

      let shouldDisplay = message.id === 'auto-response' ? this.state.shouldDisplayAutoResponse : true;
      if (shouldDisplay && (sender !== nextSender || message._hasError)) {
        renderedHistory.push(
          <MessageStack
            key={index}
            timestamp={message.date}
            hasError={message._hasError}
            sender={sender}
            messages={renderedMessages}
          />
        );
        renderedMessages = [];
      }
    });
    return renderedHistory;
  }

  // get length of the rendered history and if its the agent is the last, when you render that the agent is typing, remove the timestamp

  render() {
    return (
      <div
        role="textbox"
        tabIndex="0"
        data-aid="gladlyChatHistoryList"
        className={cx(
          styles.chatHistory_wrapper,
          this.props.isSelfService ? styles.chatHistory_wrapper_self_service : null
        )}
        ref={div => (this.containerElement = div)}
      >
        <ChatHistoryWrapper tabIndex="-1" isSelfService={this.props.isSelfService}>
          {this.props.isDemo && <SelectedAnswerHistoryItemContainer />}
          <WelcomeMessageContainer />
          {this.renderMessageHistory()}
          {this.props.isAgentTyping ? <TypingIndicator /> : null}
          {this.props.isChatEnded ? <EndMessageContainer /> : null}
        </ChatHistoryWrapper>
      </div>
    );
  }
}

ChatHistory.propTypes = {
  isAgentTyping: PropTypes.bool,
  isChatEnded: PropTypes.bool.isRequired,
  isDemo: PropTypes.bool,
  isSelfService: PropTypes.bool,
  messageHistory: PropTypes.array,
};

function getSender(message) {
  if (!message) {
    return null;
  }
  return message.isUser ? Communicators.CUSTOMER : Communicators.AGENT;
}

export default ChatHistory;

const ChatHistoryWrapper = overrideStyle('div')`
  font-family: ${p =>
    p.isSelfService
      ? p.theme.fontLibrary.secondary
        ? p.theme.fontLibrary.secondary
        : p.theme.fontLibrary.primary
      : 'inherit'};
  height: 100%;
  &:focus {
    border: none;
    outline: none;
  }
`;
